import { createReducer } from '@reduxjs/toolkit';

import {
  panelHidden,
  panelToggled,
  dirtyStateUpdated,
  reformatConfigLoaded,
  panelShown,
} from '../thunks/editor.thunks';

import type { ConfigPanelType } from '../../types/state.types';
import type { PipeConfig } from '../../types/pipes.types';

type EditorState = {
  reformatConfig: any;
  visiblePanels: {
    [key in ConfigPanelType]: boolean;
  };
  isDirty: boolean;
  unsavedEditedConfig?: PipeConfig;
};

const initialState: EditorState = {
  reformatConfig: {}, // TODO: this should have a default
  visiblePanels: {
    options: false,
    schema: false,
    templates: false,
  },
  isDirty: false,
};

/*
Note: We are using the builder callback for creating a typesafe reducer.
See https://redux-toolkit.js.org/usage/usage-with-typescript#building-type-safe-reducer-argument-objects
*/
export const editorReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(panelToggled, (state, action) => {
      state.visiblePanels[action.payload] = !state.visiblePanels[action.payload];
    })
    .addCase(panelShown, (state, action) => {
      state.visiblePanels[action.payload] = true;
    })
    .addCase(panelHidden, (state, action) => {
      state.visiblePanels[action.payload] = false;
    })
    .addCase(reformatConfigLoaded, (state, action) => {
      state.reformatConfig = action.payload;
    })
    .addCase(dirtyStateUpdated, (state, action) => {
      state.isDirty = action.payload.isDirty;
      state.unsavedEditedConfig = action.payload?.unsavedEditedConfig;
    })
);
